var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2FC6F6",
    fillRule: "evenodd",
    d: "M17 0c1.075 0 2.126.1 3.146.29.487.092.694.67.53 1.138a3.479 3.479 0 002.948 4.615c.296.002.519.27.492.565a7.465 7.465 0 008.902 8.011c.419-.083.846.18.89.604.06.583.092 1.177.092 1.777 0 9.389-7.611 17-17 17S0 26.389 0 17 7.611 0 17 0zm.5 23a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM9 18a2 2 0 100 4 2 2 0 000-4zm13-1a2 2 0 100 4 2 2 0 000-4zm-8.5-9a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.f65ea89e94c2725d8f04549331fe65a1.svg";
export { ForwardRef as ReactComponent };